<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col class="pa-0">
            <v-tabs
                app
                show-arrows
                :height="32"
				class="tabs-route"
                background-color="transparent"
                slider-color="primary">
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/'}" key="suppliers" >Fornitore</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/destinations' }" key="destinations" v-if="$store.getters.checkModelPermissions('supplierdestination')">Destinazioni</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/contacts' }" key="contacts" v-if="$store.getters.checkModelPermissions('suppliercontact')">Contatti</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/deadlines' }" key="deadlines" v-if="$store.getters.checkModelPermissions('supplierdeadline')">Scadenze</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/payments' }" key="payments" v-if="$store.getters.checkModelPermissions('supplierpayment')">Pagamenti</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/purchaseorders' }" key="purchaseorders" v-if="$store.getters.checkModelPermissions('purchaseorder')">Ordini di Acquisto</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/purchaseddts' }" key="purchaseddts" v-if="$store.getters.checkModelPermissions('purchaseddt')">DDT di Acquisto</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/purchaseinvoices' }" key="purchaseinvoices" v-if="$store.getters.checkModelPermissions('purchaseinvoice')">Fatture di Acquisto</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/suppliercreditnotes' }" key="suppliercreditnotes" v-if="$store.getters.checkModelPermissions('suppliercreditnote')">Note di Credito</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/analytics' }" key="analytics">Statistiche</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/portal-users' }" key="portal-users" v-if="$store.getters.checkModulePermissions('portal')">Accessi Fornitore</v-tab>
                <v-tab exact-path ripple :to="{ path: '/suppliers/' + id + '/portal-dms' }" key="portal-dms" v-if="$store.getters.checkModulePermissions('portal')">Area Fornitore</v-tab>
            </v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :entity-title="entityTitle"></router-view>
            </v-slide-y-reverse-transition>
        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'supplier-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                model: {},
            }
        },

        computed: {
            entityTitle()  {
                return this.model ? ['business_name'].reduce((acc, key) => this.model[key] ? acc.concat(this.model[key]) : acc, []).join(' / ') : ''
            }
        },        

        created() {
            this.$store.commit('endProgress')
            this.axios.get('suppliers/' + this.id + '?&lite=1').then(response => {
                this.model = response.data.model

            }, response => {
                // error callback
            })
        },
    }
</script>
